import React from 'react';

const AdditionalInformationSection = ({ jobData, handleInputChange }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">Additional Information</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Travel Required
          </label>
          <select
            name="travel_required"
            value={jobData.travel_required}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="none">None</option>
            <option value="occasional">Occasional</option>
            <option value="frequent">Frequent</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Education Required
          </label>
          <select
            name="education_required"
            value={jobData.education_required}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="high-school">High School</option>
            <option value="bachelor">Bachelor's Degree</option>
            <option value="master">Master's Degree</option>
            <option value="phd">PhD</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Reporting Manager
          </label>
          <input
            type="text"
            name="reporting_manager"
            value={jobData.reporting_manager}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="e.g. John Doe, Engineering Manager"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Team Size
          </label>
          <input
            type="number"
            name="team_size"
            value={jobData.team_size}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="5"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Application Deadline
          </label>
          <input
            type="date"
            name="application_deadline"
            value={jobData.application_deadline}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Start Date
          </label>
          <input
            type="date"
            name="start_date"
            value={jobData.start_date}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
      </div>

      <div className="mt-6">
        <div className="flex items-center">
          <input
            type="checkbox"
            id="remote_work_allowed"
            name="remote_work_allowed"
            checked={jobData.remote_work_allowed}
            onChange={handleInputChange}
            className="h-4 w-4 text-primary focus:ring-primary border-border rounded"
          />
          <label htmlFor="remote_work_allowed" className="ml-2 text-sm font-medium text-foreground">
            Remote work allowed
          </label>
        </div>
      </div>
    </div>
  );
};

export default AdditionalInformationSection;